import $ from "jquery";
import lazySizes from "lazysizes";
import sliders from "./sliders";
import twoColumnAlternating from "../components/twoColumnAlternating";
// Setting Up Media Queries for all the responsive images.
lazySizes.cfg.customMedia = {
	"--small": "(max-width: 320px)",
	"--medium": "(min-width: 321px) and (max-width: 768px)",
	"--large": "(min-width: 769px) and (max-width: 1024px)",
};

export default {
	init() {
		sliders.init();
		twoColumnAlternating.init();
		// Match Height Helper Class
		$(".match-height-row").matchHeight({
			byRow: true,
			property: "min-height",
		});
		$(".match-height").matchHeight({
			byRow: false,
			property: "min-height",
		});

		$(".ai-two-column-image-swap .content-box").hover(
			function () {
				$(".box-top").removeClass("active");
				var data_id = $(this).data("id");

				//if(parseInt($('box-top').data("id")) == data_id) {
				$(".box-top[data-id = " + data_id + "]").addClass("active");
				//}
			},
			function () {}
		);

		// Team Block
		$(".see-more-team").on("click", function () {
			$(".team-member").hasClass("hidden").removeClass("hidden");
			$(this).addClass("hidden");
		});

		// **** *
		// Marketecture Popups
		// *****

		// close when clicking somewhere else on page
		$("body").click(function (e) {
			var toggle = $(".marketecture-popup-toggle"),
				toggle2 = $(".marketecture-popup");
			if (
				!toggle.is(e.target) &&
				toggle.has(e.target).length === 0 &&
				!toggle2.is(e.target) &&
				toggle2.has(e.target).length === 0
			) {
				$(".marketecture-popup-toggle").removeClass("active");
				$(".marketecture-popup").removeClass("active");
				$(".ai-block-marketecture").removeClass("right-open");
			}
		});
		// click to open
		$(".marketecture-popup-toggle").click(function (e) {
			$(".marketecture-popup").removeClass("active");
			$(".ai-block-marketecture").removeClass("right-open");

			var $this = $(this),
				$module = $(".ai-block-marketecture"),
				$popup = $(
					'.marketecture-popup[data-id="' + $this.data("popup") + '"]'
				),
				$arrows = $popup.children(".before, .after"),
				$top = 0,
				$left = 0,
				$right = 0,
				$bottom = 0;

			// if toggle is active, or toggle isn't the row title and parent doesn't have popups enabled
			if (
				$this.hasClass("active") ||
				($this.parents(".boxes-row").hasClass("popups-") &&
					!$this.hasClass("row-title"))
			) {
				$(".marketecture-popup-toggle").removeClass("active");
			} else {
				$(".marketecture-popup-toggle").removeClass("active");
				$this.addClass("active");
				$popup.addClass("active");
				if ($this.hasClass("right-block")) {
					if ($(window).width() > 991) {
						($top = $(".right-blocks").offset().top - $module.offset().top),
							($left =
								$(".graphic-left").offset().left +
								$(".graphic-left").width() / 2),
							($right =
								$(window).width() -
								$(".graphic-left").offset().left -
								$(".graphic-left").width() +
								10),
							($bottom =
								$module.offset().top +
								$module.outerHeight() -
								$(".right-blocks").offset().top -
								$(".right-blocks").height());

						$arrows
							.css(
								"top",
								$this.offset().top - $(".right-blocks").offset().top + 60
							)
							.css("left", "100%");
					} else {
						($top = $this.offset().top - $module.offset().top + 132),
							($left = $(".graphic-left").offset().left),
							($right =
								$(window).width() -
								$(".graphic-left").offset().left -
								$(".graphic-left").width()),
							($bottom =
								$module.offset().top +
								$module.outerHeight() -
								$(".right-blocks").offset().top -
								$(".right-blocks").height());

						$arrows
							.css("top", "auto")
							.css("bottom", "100%")
							.css("left", $(window).width() / 2 - 35);
					}

					$(".ai-block-marketecture").addClass("right-open");
					$popup
						.css("top", $top)
						.css("left", $left)
						.css("right", $right)
						.css("bottom", $bottom);
				} else {
					if ($(window).width() > 991) {
						($left = $(".graphic-left").offset().left + 18),
							($right =
								$(window).width() -
								$(".graphic-left").offset().left -
								$(".graphic-left").width() +
								18);
						if ($this.hasClass("row-title")) {
							$top = $this.offset().top - $module.offset().top + 40;
						} else {
							$top = $this.offset().top - $module.offset().top + 96;
						}
					} else {
						($left = $(".graphic-left").offset().left),
							($right =
								$(window).width() -
								$(".graphic-left").offset().left -
								$(".graphic-left").width());
						if ($this.hasClass("row-title") && $(window).width() > 600) {
							$top = $this.offset().top - $module.offset().top + 40;
						} else if ($this.hasClass("row-title")) {
							$top = $this.offset().top - $module.offset().top + 65;
						} else {
							$top = $this.offset().top - $module.offset().top + 93;
						}
					}
					$popup.css("top", $top).css("left", $left).css("right", $right);
					$arrows.css(
						"left",
						$this.offset().left - $left - 3 + $this.width() / 2
					);
				}
			}
		});
		$(".accordion-toggle").click(function () {
			$(this).parents(".accordion").toggleClass("visible");
		});

		// Sticky Datasheet Sidebar
		if ($(".left-content-wrapper").length > 0) {
			var $contentwrapper = $(".success-main-content"),
				$sidenavigation = $(".left-content-wrapper"),
				scrollTop = $(window).scrollTop(),
				navHeight = $sidenavigation.height(),
				windowHeight = $(window).height(),
				contentTop = $contentwrapper.offset().top,
				contentBottom =
					contentTop + $contentwrapper.height() - $(window).height();
			$(window).scroll(function () {
				(scrollTop = $(window).scrollTop()),
					(windowHeight = $(window).height()),
					(contentTop = $contentwrapper.offset().top),
					(contentBottom = contentTop + $contentwrapper.outerHeight());
				if (
					scrollTop > contentTop &&
					scrollTop + navHeight < contentBottom - 160
				) {
					$sidenavigation.addClass("stuck");
				} else {
					$sidenavigation.removeClass("stuck");
				}
				if (scrollTop + navHeight > contentBottom - 160) {
					$sidenavigation.addClass("bottom");
				} else {
					$sidenavigation.removeClass("bottom");
				}
			});
		}
		// Sticky Resource Sidebar
		if ($(".resource-left-content-wrapper").length > 0) {
			var $contentwrapper = $(".resource-main-content"),
				$sidenavigation = $(".resource-left-content-wrapper"),
				scrollTop = $(window).scrollTop(),
				navHeight = $sidenavigation.height(),
				windowHeight = $(window).height(),
				contentTop = $contentwrapper.offset().top,
				contentBottom =
					contentTop + $contentwrapper.height() - $(window).height();
			$(window).scroll(function () {
				(scrollTop = $(window).scrollTop()),
					(windowHeight = $(window).height()),
					(contentTop = $contentwrapper.offset().top),
					(contentBottom = contentTop + $contentwrapper.outerHeight());
				if (
					scrollTop + 100 > contentTop &&
					scrollTop + navHeight < contentBottom - 160
				) {
					$sidenavigation.addClass("stuck");
				} else {
					$sidenavigation.removeClass("stuck");
				}
				if (scrollTop + navHeight > contentBottom - 160) {
					$sidenavigation.addClass("bottom");
				} else {
					$sidenavigation.removeClass("bottom");
				}
			});
		}
		//Floating Heads
		setInterval(function () {
			if ($($(".additional-artifact.a2")).is(":visible")) {
				$(".original-artifact.a2").fadeIn();
				$(".additional-artifact.a2").fadeOut();
			} else {
				$(".additional-artifact.a2").fadeIn();
				$(".original-artifact.a2").fadeOut();
			}
		}, 3500);
		setInterval(function () {
			if ($($(".additional-artifact.a3")).is(":visible")) {
				$(".original-artifact.a3").fadeIn();
				$(".additional-artifact.a3").fadeOut();
			} else {
				$(".additional-artifact.a3").fadeIn();
				$(".original-artifact.a3").fadeOut();
			}
		}, 4500);
		setInterval(function () {
			if ($($(".additional-artifact.a4")).is(":visible")) {
				$(".original-artifact.a4").fadeIn();
				$(".additional-artifact.a4").fadeOut();
			} else {
				$(".additional-artifact.a4").fadeIn();
				$(".original-artifact.a4").fadeOut();
			}
		}, 5500);
		setInterval(function () {
			if ($($(".additional-artifact.a5")).is(":visible")) {
				$(".original-artifact.a5").fadeIn();
				$(".additional-artifact.a5").fadeOut();
			} else {
				$(".additional-artifact.a5").fadeIn();
				$(".original-artifact.a5").fadeOut();
			}
		}, 5000);
		setInterval(function () {
			if ($($(".additional-artifact.a6")).is(":visible")) {
				$(".original-artifact.a6").fadeIn();
				$(".additional-artifact.a6").fadeOut();
			} else {
				$(".additional-artifact.a6").fadeIn();
				$(".original-artifact.a6").fadeOut();
			}
		}, 6000);

		// *****
		// Hero Fader
		// *****

		if ($(".ai-block-hero-fader .background-image").length) {
			const target = document.querySelector(".ai-block-hero-fader .initial-content");
			// create callback
			function callback(entries, observer) {
				entries.forEach((entry) => {
					// only add scroll event listener if hero is in viewport
					if (entry.isIntersecting) {
						// doFades();
						doSimpleFadeIns();
					} else {
						doSimpleFadeOuts();
					}
				});
			}
			// create observer
			function createObserver(target, callback) {
				const options = {
						root: null,
						threshold: .65
				};
				const observer = new IntersectionObserver(callback, options);
				observer.observe(target);
			}
			// simple fade-ins
			function doSimpleFadeIns() {
				// background blur
				$(".ai-block-hero-fader .background-image__inner").css("filter", "blur(" + 0 + "px)");
				$(".ai-block-hero-fader .background-image .overlay").css("opacity", 1);

				// title fades
				if ($(".ai-block-hero-fader .initial-content").length) {
					$(".ai-block-hero-fader .initial-content").css("opacity", 1);
				}
			}
			// simple fade-outs
			function doSimpleFadeOuts() {
				// background blur
				$(".ai-block-hero-fader .background-image__inner").css("filter", "blur(" + 10 + "px)");
				$(".ai-block-hero-fader .background-image .overlay").css("opacity", 0);

				// title fades
				if ($(".ai-block-hero-fader .initial-content").length) {
					$(".ai-block-hero-fader .initial-content").css("opacity", .1);
				}
			}
			// call observer
			createObserver(target, callback);
		}

		// Anchor animations
		$(".content-styled a:not(.btn)").each(function () {
			$(this).html("<span>" + $(this).html() + "<span>");
		});

		// Video popups
		$("a:not(.social-link)").on("click", function (e) {
			var $target = $(this).attr("href");
			if ($target.toLowerCase().indexOf("vimeo") >= 0) {
				e.preventDefault();
				var $n = $target.lastIndexOf("/");
				var $vid = $target.substring($n + 1);
				$(".video-popup-wrapper .popup-content").html(
					'<iframe src="https://player.vimeo.com/video/' +
						$vid +
						'/?autoplay=1&api=1" width="500" height="281" frameborder="0" webkitallowfullscreen mozallowfullscreen allowfullscreen></iframe>'
				);
				$(".video-popup-wrapper").addClass("active");
			}
			if ($target.toLowerCase().indexOf("youtu") >= 0) {
				e.preventDefault();
				if ($target.toLowerCase().indexOf("youtu.be") >= 0) {
					var regExp = /^.*(youtu\.be\/|v\/|u\/\w\/|embed\/|watch\?v=|\&v=)([^#\&\?]*).*/;
					var match = $target.match(regExp);
					if (match && match[2].length == 11) {
						var $yid = match[2];
					}
				} else {
					var $y = $target.lastIndexOf("=");
					var $yid = $target.substring($y + 1);
				}
				$(".video-popup-wrapper .popup-content").html('<iframe src="https://www.youtube.com/embed/' + $yid + '" width="500" height="281" title="YouTube video player" frameborder="0" allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share" allowfullscreen></iframe>');
				$(".video-popup-wrapper").addClass("active");
			}
			if ($target.toLowerCase().indexOf("mp4") >= 0) {
				e.preventDefault();
				$(".video-popup-wrapper .popup-content").html(
					'<video autoplay><source src="' +
						$target +
						'" type="video/mp4"></video>'
				);
				$(".video-popup-wrapper").addClass("active");
				//$('body, html').addClass('body-noscroll');
			}
			if ($(this).hasClass("popup-toggle")) {
				e.preventDefault();
				if (!$(`body`).hasClass("body--popup-active")) {
					$(`body`).addClass("body--popup-active");
				}
				$($target).addClass("active");
				if ($($target).find(".javascript-top").length > -1) {
					$($target)
						.find(".javascript-top")
						.css("top", $(window).scrollTop() + 180);
				}
			}
		});
		$(".close-popup").each(function () {
			$(this).on("click", function () {
				$(".popup-curved").each(function () {
					$(this).removeClass("active");
				});

				$(".popup-team").each(function () {
					$(this).removeClass("active");
				});
				$(".video-popup-wrapper").each(function () {
					$(this).removeClass("active");
				});
				$(".video-modal").each(function () {
					$(this).fadeOut("150");
					$(this)
						.find("iframe")
						.each(function (index, iframe) {
							$(iframe).attr("src", $(iframe).attr("src"));
						});
				});
				$(".video-popup-wrapper .popup-content").each(function () {
					$(this).html("");
				});
				if ($(`body`).hasClass(`body--popup-active`)) {
					$(`body`).removeClass(`body--popup-active`);
				}
				//$('body, html').removeClass('body-noscroll');
			});
		});

		$(".thought-leadership-popup-positioner")
			.parent()
			.on("click", function (e) {
				// console.log(e);
				if ($(e.target).hasClass("modal")) {
					e.stopPropagation();
					$(this).fadeOut("200");
				}
			});

		// Global Anchors
		$("a").on("click", function (e) {
			var $href = $(this).attr("href");
			if ($href) {
				if (
					$href.match("^#") &&
					!$(this).hasClass("toggle") &&
					!$(this).hasClass("popup-toggle")
				) {
					e.preventDefault();
					if ($($href).length) {
						$("html, body")
							.stop()
							.animate(
								{
									scrollTop: $($href).offset().top,
								},
								1500
							);
					}
				}
			}
		});

		// Global Accordions
		$(".accordion-item").on('click', function () {
			$(this).toggleClass("active");
		});

		// Global Tabs
		$(".tab-toggle").click(function () {
			$(this).siblings(".tab-toggle").removeClass("active");
			$(this).addClass("active");
			$(".tab-item-content-alternate").removeClass("active");
			$(
				'.tab-item-content-alternate[data-tab="' + $(this).data("id") + '"'
			).addClass("active");
			$(this)
				.parents(".tabs-titles")
				.siblings(".tabs-contents")
				.children(".tab-item-content")
				.removeClass("active");
			$(this)
				.parents(".tabs-titles")
				.siblings(".tabs-contents")
				.children(".tab-item-content#" + $(this).data("id"))
				.addClass("active");
		});
		$(document).on("click", ".tabs-titles--arrows", function (e) {
			if (e.offsetX && $(window).width() <= 768) {
				if (e.offsetX < 60) {
					tabto($(this), -1);
				} else if (e.offsetX > $(this).outerWidth() - 60) {
					tabto($(this), 1);
				}
			}
		});
		$(document).on("touchstart", ".tabs-titles--arrows", function (e) {
			$(this).data("start-screenX", e.touches[0].screenX);
		});
		$(document).on("touchend", ".tabs-titles--arrows", function (e) {
			if ($(window).width() <= 768) {
				var diff = $(this).data("start-screenX") - e.changedTouches[0].screenX;
				if (Math.abs(diff) > 30) {
					tabto($(this), diff);
				}
			}
		});

		function tabto($tabs, direction) {
			//console.log('tabto',direction);
			var $e = $tabs.find(".active").removeClass("active").eq(0),
				$siblings = $e.siblings();

			if (direction > 0) {
				if ($e.index() >= $siblings.length) {
					$siblings.first().click();
				} else {
					$e.next().click();
				}
			} else {
				if ($e.index() <= 0) {
					$siblings.last().click();
				} else {
					$e.prev().click();
				}
			}
		}

		// Global Navigation Mobile Menu
		$("#mobile-nav-toggle").on("click", function (e) {
			e.preventDefault();
			var nav_open = $("html").hasClass("nav-open");
			$("html").toggleClass("nav-open", !nav_open);
			$("#global-nav").toggleClass("active", !nav_open);
			$("#mobile-nav").toggleClass("active", !nav_open);
			$("#menu-mobile .sub-menu").removeClass("active");
		});
		$("#menu-mobile .sub-menu").each(function () {
			$(this).prepend(
				'<li class="menu-item level-back"><a href="#back">&nbsp;</a></li>'
			);
			$(this).append(
				'<li class="menu-item button js-appended"><a href="/request-a-demo/">Get started</a></li>'
			);
		});
		$("#menu-mobile").append(
			'<li class="menu-item button js-appended"><a href="/request-a-demo/">Get started</a></li>'
		);
		$("#menu-mobile .menu-item-has-children > a").on("click", function (e) {
			e.preventDefault();
			$(this).next(".sub-menu").addClass("active");
		});
		$("#menu-mobile .sub-menu").on("click", ".level-back", function (e) {
			e.preventDefault();
			$(this).parents(".sub-menu").removeClass("active");
		});
		$("#close-mobile-nav").on("click", function (e) {
			e.preventDefault();
			$("#global-nav").toggleClass("active");
			$("#mobile-nav").toggleClass("active");
			$("#menu-mobile .sub-menu").removeClass("active");
		});

		// Values Video Block
		function values() {
			if ($(".value-item").length < 0) {
				$(".value-item").each(function () {
					var $this = $(this),
						$content = $this.children(".value-content");
					$(".values-wrapper").removeClass("loaded");
					$this.removeClass("loaded");
					$content.css("height", "120px");
					setTimeout(function () {
						$this.addClass("loaded");
						$(".values-wrapper").addClass("loaded");
					}, 600);
					setTimeout(function () {
						$(".values-wrapper").css(
							"height",
							$(".values-wrapper").outerHeight()
						);
						$(".values-wrapper").addClass("loaded");
					}, 1000);
				});
			}
		}

		//Overflowing BH Height
		$(window).resize(function () {
			var block1 = $(".ai-block-stats.four-col").height();
			var block2 = $(".ai-block-tabbed-box.full-screen").height();
			var full_height = block1 + block2 - 100;
			setTimeout(function () {
				$(".ai-block-stats.four-col .background").css(
					"height",
					full_height + "px"
				);
			}, 500);
		});

		// Animations
		function animations() {
			const elementsToObserve = document.querySelectorAll(".animate");
			const circleElementsToObserve =
				document.querySelectorAll(".animate--circle");

			let options = {
				root: null,
				rootMargin: "0px",
				threshold: 0.01,
			};
			let circleOptions = {
				root: null,
				rootMargin: "0px 0px -60% 0px ",
				threshold: 0.01,
			};
			let observerCallback = (entries) => {
				entries.forEach((entry) => {
					// let $animateThis = entry;
					// console.log(entry);
					if (entry.isIntersecting) {
						// let element = entry.target;
						// if( element. )
						// console.log(entry.target);
						if (!entry.target.classList.contains("reveal")) {
							// console.log(entry);
							let durations = [100, 200, 300, 400, 500, 1000, 1500, 2000];
							durations.forEach(function (time) {
								if (time != 100) {
									setTimeout(function () {
										entry.target.classList.add(`reveal${time}`);
									}, time);
								} else {
									setTimeout(function () {
										entry.target.classList.add(`reveal`);
									}, time);
								}
							});
							return observer.unobserve(entry.target);
						}
					}
				});
			};
			let observer = new IntersectionObserver(observerCallback, options);
			let circleObserver = new IntersectionObserver(
				observerCallback,
				circleOptions
			);
			elementsToObserve.forEach((element) => {
				observer.observe(element);
			});

			circleElementsToObserve.forEach((element) => {
				circleObserver.observe(element);
			});

			// $('.animate').each(function () {
			// 	var $animatethis = $(this);
			// 	if (
			// 		$animatethis.offset().top <
			// 		$(window).scrollTop() + $(window).height() - 100
			// 	) {
			// 		setTimeout(function () {
			// 			$animatethis.addClass('reveal');
			// 		}, 100);
			// 		setTimeout(function () {
			// 			$animatethis.addClass('reveal200');
			// 		}, 200);
			// 		setTimeout(function () {
			// 			$animatethis.addClass('reveal300');
			// 		}, 300);
			// 		setTimeout(function () {
			// 			$animatethis.addClass('reveal400');
			// 		}, 400);
			// 		setTimeout(function () {
			// 			$animatethis.addClass('reveal500');
			// 		}, 500);
			// 		setTimeout(function () {
			// 			$animatethis.addClass('reveal1000');
			// 		}, 1000);
			// 		setTimeout(function () {
			// 			$animatethis.addClass('reveal1500');
			// 		}, 1500);
			// 		setTimeout(function () {
			// 			$animatethis.addClass('reveal2000');
			// 		}, 2000);
			// 	}
			// });
		}

		animations();

		// Scroll functions
		$(window).scroll(function () {
			animations();
		});

		// Load functions
		$(window).on("load", function () {
			setTimeout(function () {
				values();
				animations();
			}, 100);
			$(window).trigger("resize");
			$(window).trigger("scroll");
			setTimeout(function () {
				$(window).trigger("resize");
				$(window).trigger("scroll");
			}, 500);
		});

		// Resize functions
		$(window).bind("resize", function () {
			values();
		});

		// Global Pagination
		$("#pagination").on("click", "a", function (e) {
			e.preventDefault();
			$(this).remove();
			$("#ajax-loader").load(
				$(this).attr("href") + " #ajax-posts>*",
				function () {
					$("#ajax-posts").append($("#ajax-loader").html());
					animations();
				}
			);
			$("#pagination").load($(this).attr("href") + " #pagination>*");
		});

		// Multi Filter
		$("body").click(function (e) {
			if (!$(e.target).hasClass("toggle") && !$(e.target).hasClass("option")) {
				$(".multi-filter").removeClass("open");
				$(".single-filter").removeClass("open");
			}
		});
		$(".multi-filter > .toggle").click(function () {
			$(this)
				.parents(".multi-filter")
				.siblings(".multi-filter")
				.removeClass("open");
			$(this)
				.parents(".multi-filter")
				.siblings(".single-filter")
				.removeClass("open");
			$(this).parents(".multi-filter").toggleClass("open");
		});
		$(".multi-filter .option").click(function () {
			$(this).toggleClass("checked");
		});
		$(".single-filter > .toggle").click(function () {
			$(this)
				.parents(".single-filter")
				.siblings(".multi-filter")
				.removeClass("open");
			$(this)
				.parents(".single-filter")
				.siblings(".single-filter")
				.removeClass("open");
			$(this).parents(".single-filter").toggleClass("open");
		});
		$(".single-filter .option").click(function () {
			$(this).parents(".single-filter").toggleClass("open");
			$(this).siblings(".option").removeClass("checked");
			$(this).addClass("checked");
		});

		// verticals grid block hovers
		if (
			$(".ai-block-verticals-grid .verticals-grid").length &&
			$(".vertical-block").length
		) {
			$(".vertical-block").each(function () {
				let $blockUpper = $(this).find(".block-upper"),
					$blockLower = $(this).find(".block-lower"),
					blockLowerOffset = $blockLower.outerHeight() / 2;

				$blockUpper.css({
					transform: "translateY(" + blockLowerOffset + "px)",
				});
			});
		}

		$("[data-scroll-fsticky]").each(function (i, e) {
			var sj = {
				$element: $(e),
				$parent: $(e).parent(),
				$items: $(e).find($(e).data("scroll-fsticky")),
				start_top: 0,
				stop_top: 0,
				offset_top: 0,
				height: 0,
				total_height: 0,
				window_width: 0,
				setup: function () {
					this.start_top = 0;
					this.stop_top = 0;
					this.offset_top = 0;
					this.height = 0;
					this.total_height = 0;
					this.window_width = $(window).width();
					this.$items
						.parent()
						.css("height", "")
						.removeClass("ai-cards-initialized");
					this.$parent.css("height", "").css("position", "");
					this.$element.css({ position: "", top: "", width: "" });
					this.$items.css({ opacity: 1 });

					if (this.window_width >= 1024) {
						var max_item_height = 0;
						this.$items.each(function () {
							max_item_height = Math.max(
								max_item_height,
								$(this).outerHeight()
							);
						});
						this.$items
							.parent()
							.addClass("ai-cards-initialized")
							.height(max_item_height);

						this.height = this.$element.outerHeight();
						this.total_height =
							this.height + (max_item_height + 200) * this.$items.length;
						this.$parent.css("position", "relative").height(this.total_height);
						this.$element.css({
							position: "absolute",
							top: "0px",
							width: "100%",
						});

						this.start_top = Math.floor(
							this.$items.first().offset().top - $(window).height() / 2
						);
						this.offset_top = Math.floor(
							this.start_top - this.$element.offset().top
						);
						this.stop_top = Math.floor(
							this.$element.offset().top +
								this.total_height -
								(this.height - this.offset_top)
						);
					}
				},
				scroll: function () {
					if (this.window_width >= 1024) {
						var scroll = $(window).scrollTop();
						if (scroll >= this.start_top && scroll <= this.stop_top) {
							this.$element.css({
								position: "fixed",
								top: -this.offset_top + "px",
							});
						} else {
							this.$element.css({
								position: "absolute",
								top:
									(scroll >= this.stop_top
										? this.total_height - this.height
										: 0) + "px",
							});
						}
						//this.set_index(Math.floor( this.$items.length * (scroll - this.start_top) / (this.stop_top - this.start_top) ));
						this.set_progress(
							((scroll - this.start_top) * 100) /
								(this.stop_top - this.start_top)
						);
					}
				},
				set_progress: function (progress) {
					var l = this.$items.length,
						li = 100 / l,
						li_s = li * 0.2,
						li_e = li * 0.8,
						p = Math.max(0, Math.min(100, progress)),
						current = Math.floor(p / li);
					this.$items.each(function (i, e) {
						var x = Math.max(0, Math.min(li, p - i * li)),
							o = 0;
						//Trapezoid function
						if (x <= li_s) {
							//Fade In
							if (i === 0 && i === current) {
								//First item
								o = 1;
							} else {
								o = x / li_s;
							}
						} else if (x >= li_e) {
							//Fade Out
							if (i === l - 1 && i <= current) {
								//Last item
								o = 1;
							} else {
								o = (li - x) / (li - li_e);
							}
						} else {
							o = 1; //Trapezoid plateau
						}
						$(e).css("opacity", o);
					});
				},
			};
			if (sj.$items.length) {
				$(window).resize(function () {
					sj.setup();
					sj.scroll();
				});
				$(window).scroll(function () {
					sj.scroll();
				});
				sj.setup();
				sj.scroll();
			}
			$(e).data("sj", sj);
		});

		// column blocks accordions
		if (
			$(
				".ai-block--column-blocks-slider.ai-block--type-accordion [data-accordion-toggle]"
			).length
		) {
			// $("[data-accordion-toggle]").mouseenter(function (e) {
			//   $(this).parent(".block").siblings(".block").children("[data-accordion-toggle]").removeClass("active");
			//   $(this).parent(".block").siblings(".block").children("[data-accordion-toggle]").children(".text").fadeOut("250");
			// });
			$("[data-accordion-toggle]").click(function (e) {
				e.preventDefault();

				let $thisAccordion = $(this);
				let $thisText = $(".text", $thisAccordion);

				$thisAccordion.toggleClass("active");
				$thisText.fadeToggle("250");
			});
		}

		// video carousel block - modal toggles
		if ($(".video-modal-toggler[data-video]").length) {
			// open modal
			$(".video-modal-toggler[data-video]").click(function (e) {
				e.preventDefault();

				let thisSlug = $(this).data("video"),
					$thisModal = $('.video-modal[data-video="' + thisSlug + '"]');

				$(".video-modal").hide();
				$thisModal.fadeIn("200");
			});

			// close modal
			$(".video-modal .close").on("click", function (e) {
				$(this).parents(".video-modal").fadeOut("200");
			});
		}

		/******
		VIDEO ARCHIVE PAGE
		******/

		// filter videos
		function filterVideos(categorySlug, categoryName, sortType) {
			// remove old category filter tag from grid
			$(".video-filter-items").find("li.category-filter-item").remove();

			// remove checked attr from category filter dropdown
			$("#category-filter .option.checked").removeClass("checked");

			// if there's a new category to filter by
			if (categorySlug && categoryName) {
				// add its filter tag to grid
				$(".video-filter-items").append(
					'<li class="filter-item category-filter-item" data-value="' +
						categorySlug +
						'">' +
						categoryName +
						"</li>"
				);
				// update category filter active option
				$(
					'#category-filter .option[data-value="' + categorySlug + '"]'
				).addClass("checked");
			}

			// hide 'no videos' notice if it's visible
			if ($(".videos-grid .videos-grid-row .no-videos:visible")) {
				$(".videos-grid .videos-grid-row .no-videos").hide();
			}

			// show hidden videos
			$(".videos-grid .single-video-col").removeClass("hide");

			// if there's a new category to filter by, do it
			if (categorySlug && categoryName) {
				$(
					'.videos-grid .single-video-col:not([data-types*="' +
						categorySlug +
						'"])'
				).addClass("hide");
			}

			// sort visible videos by most recent ('data-date' attr)
			if (sortType == "recent") {
				$(".videos-grid-row .single-video-col:visible")
					.sort(function (a, b) {
						let aDate = $(a).attr("data-date"),
							bDate = $(b).attr("data-date");

						return aDate < bDate ? 1 : aDate > bDate ? -1 : 0;
					})
					.appendTo(".videos-grid-row");

				// sort visible videos by popularity ('data-popularity' attr)
			} else if (sortType == "popular") {
				$(".videos-grid-row .single-video-col:visible")
					.sort(function (a, b) {
						let aPopularity = parseInt($(a).attr("data-popularity")),
							bPopularity = parseInt($(b).attr("data-popularity"));

						return aPopularity <= bPopularity
							? 1
							: aPopularity > bPopularity
							? -1
							: 0;
					})
					.appendTo(".videos-grid-row");
			}

			// hide the 'load more' button after filtering
			$(".load-more-wrapper").hide();

			// if no videos found, show notice
			if (
				!$(".videos-grid .videos-grid-row .single-video-col:visible").length
			) {
				$(".videos-grid .videos-grid-row .no-videos").fadeIn("200");
			}
		}

		// category dropdown filter
		$(".video-filters #category-filter .option").click(function (e) {
			let categorySlug = $(this).attr("data-value"),
				categoryName = $(this).text(),
				sortType = $("#sort-filter .option.checked").attr("data-value");

			// filter videos
			filterVideos(categorySlug, categoryName, sortType);
		});

		// sort dropdown filter
		$(".video-filters #sort-filter .option").click(function (e) {
			let categorySlug = $("#category-filter .option.checked").attr(
					"data-value"
				),
				categoryName = $("#category-filter .option.checked").text(),
				sortType = $(this).attr("data-value"),
				sortText = $(this).text();

			// update sort dropdown text
			$("#sort-filter label.toggle span").text(sortText);

			// filter videos
			filterVideos(categorySlug, categoryName, sortType);
		});

		// clear category filter tag when clicked, then filter
		$(".video-filter-items").click(".filter-item", function (e) {
			let sortType = $("#sort-filter .option.checked").attr("data-value");

			// filter videos
			filterVideos(null, null, sortType);
		});

		// video archive page load more
		$(".videos-grid a[data-load-more]").click(function (e) {
			e.preventDefault();
			let $hiddenVideos = $(".videos-grid .single-video-col.hide"),
				$nextGroup = $hiddenVideos.slice(0, 9);

			// show next group of posts
			$nextGroup.fadeIn("200").removeClass("hide");

			// hide load more button if <= 9 hidden videos were found
			if ($hiddenVideos.length <= 9) {
				$(".videos-grid a[data-load-more]").hide();
			}
		});

		// ***********
		// thought leadership page
		// ***********

		if ($(".ai-block-insights-filter").length) {
			// deploy filter dropdown
			$(
				'.ai-block-insights-filter li[data-sf-field-input-type="checkbox"] h4'
			).on("click", function () {
				$(this).siblings("ul").fadeToggle("150");
				$(this).toggleClass("flip");
			});

			// click anywhere else, close open dropdowns
			$("body").on("click", function (e) {
				if (!$(e.target).hasClass("flip")) {
					$(
						'.ai-block-insights-filter li[data-sf-field-input-type="checkbox"] h4.flip'
					)
						.siblings("ul")
						.fadeToggle("150");
					$(
						'.ai-block-insights-filter li[data-sf-field-input-type="checkbox"] h4'
					).removeClass("flip");
				}
			});
		}

		// ***********
		// webinars & events page
		// ***********

		if ($(".ai-block-past-we").length) {
			$("body").on("click", function (e) {
				if (
					!$(e.target).hasClass("sf-field-taxonomy-webinar-event-type") &&
					!$(e.target).hasClass("sf-field-taxonomy-webinar-event-industry") &&
					!$(e.target)
						.parents("li")
						.hasClass("sf-field-taxonomy-webinar-event-type") &&
					!$(e.target)
						.parents("li")
						.hasClass("sf-field-taxonomy-webinar-event-industry")
				) {
					$(
						".sf-field-taxonomy-webinar-event-type, .sf-field-taxonomy-webinar-event-industry"
					)
						.children("h4")
						.removeClass("flip");
					$(
						".sf-field-taxonomy-webinar-event-type, .sf-field-taxonomy-webinar-event-industry"
					)
						.children("ul")
						.fadeOut("150");
				} else {
					if (
						$(e.target).hasClass("sf-field-taxonomy-webinar-event-type") ||
						$(e.target).hasClass("sf-field-taxonomy-webinar-event-industry")
					) {
						$(e.target).children("ul").fadeToggle("150");
						$(e.target).children("h4").toggleClass("flip");
					} else if ($(e.target).is("h4")) {
						$(e.target).siblings("ul").fadeToggle("150");
						$(e.target).toggleClass("flip");
					} else {
						$(
							".sf-field-taxonomy-webinar-event-type, .sf-field-taxonomy-webinar-event-industry"
						)
							.children("h4")
							.removeClass("flip");
						$(
							".sf-field-taxonomy-webinar-event-type, .sf-field-taxonomy-webinar-event-industry"
						)
							.children("ul")
							.fadeOut("150");
					}
				}
			});
		}

		// ************
		// hero bg video block
		// ************

		if (($(".ai-block-hero-bg-video").length || $(".ai-block-netreveal-home-hero").length || $(".ai-block-netreveal-home-hero-sensa-style").length) && $("#bg-video").length) {
			const bgVideo = $("#bg-video");

			if (bgVideo.is(":visible")) {
				$("source", bgVideo).each(function () {
					const el = $(this);
					el.attr("src", el.data("src"));
				});
				bgVideo[0].load();
			}
		}

		// ************
		// Real Results tabs block horizontal scroller for mobile
		// ************

		// function to check whether the arrows should display
		function checkTabsWidth() {
			// var titlesWidth = 0,
			// 		titlesContainerWidth = $('.ai-block-tabs-real-results .tabs-titles').outerWidth();

			// // get sum of all titles widths
			// $('.ai-block-tabs-real-results .tabs-titles .tab-item-title').each(function(i) {
			// 	titlesWidth += $(this).outerWidth();
			// });

			// // if sum of titles widths are greater than the title container, show scroll arrows
			// if (titlesWidth > titlesContainerWidth) {
			// 	$('.ai-block-tabs-real-results .tabs-real-results-arrows').show();
			// } else {
			// 	$('.ai-block-tabs-real-results .tabs-real-results-arrows').hide();
			// }

			// simplify: show only if mobile hamburger shows
			if ($("#mobile-nav-toggle").is(":visible")) {
				$(".ai-block-tabs-real-results .tabs-real-results-arrows").show();
			} else {
				$(".ai-block-tabs-real-results .tabs-real-results-arrows").hide();
			}
		}

		// function to determine where the container should scroll to
		function scrollLeft($title) {
			let $titlesToTheLeft = $title.prevAll(),
				spaceToScroll = 0;

			// get the space to the left of the clicked title
			$titlesToTheLeft.each(function () {
				spaceToScroll += $(this).outerWidth();
			});

			// scroll container to the clicked title
			$titlesContainer.animate({ scrollLeft: spaceToScroll });
		}

		if ($(".tabs-real-results-arrows").length) {
			var $titlesContainer = $(".tabs-real-results-arrows").siblings(
					".tabs-titles"
				),
				$contentsContainer = $(".tabs-real-results-arrows").siblings(
					".tabs-contents"
				);

			checkTabsWidth();
			$(window).resize(function () {
				checkTabsWidth();
			});

			// when user clicks on tab title, scroll that one over to the left
			$(".tab-item-title", $titlesContainer).on("click", function () {
				scrollLeft($(this));
			});

			// scroll back
			$(".tabs-real-results-arrows .slick-prev").click(function () {
				let $activeTabTitle = $(".tab-item-title.active", $titlesContainer),
					$prevActiveTabTitle = $activeTabTitle.prev(".tab-item-title"),
					$activeTabContent = $(".tab-item-content.active", $contentsContainer),
					$prevActiveTabContent = $activeTabContent.prev(".tab-item-content");

				// scroll container back to active title
				scrollLeft($prevActiveTabTitle);

				// get previous active tab
				if ($prevActiveTabTitle.length && $prevActiveTabContent.length) {
					// remove active from current tab
					$activeTabTitle.removeClass("active");
					$activeTabContent.removeClass("active");
					// shift active to next tab
					$prevActiveTabTitle.addClass("active");
					$prevActiveTabContent.addClass("active");
				}
			});

			// scroll forward
			$(".tabs-real-results-arrows .slick-next").click(function () {
				let $activeTabTitle = $(".tab-item-title.active", $titlesContainer),
					$nextActiveTabTitle = $activeTabTitle.next(".tab-item-title"),
					$activeTabContent = $(".tab-item-content.active", $contentsContainer),
					$nextActiveTabContent = $activeTabContent.next(".tab-item-content");

				// scroll container forward to active title
				scrollLeft($nextActiveTabTitle);

				// get next active tab
				if ($nextActiveTabTitle.length && $nextActiveTabContent.length) {
					// remove active from current tab
					$activeTabTitle.removeClass("active");
					$activeTabContent.removeClass("active");
					// shift active to next tab
					$nextActiveTabTitle.addClass("active");
					$nextActiveTabContent.addClass("active");
				}
			});
		}

		// ************
		// New click-open dropdown nav
		// ************
		$("#global-nav li.click-open.menu-item").on("click", function () {
			$("#global-nav li.click-open.menu-item").removeClass("open");
			$(this).toggleClass("open");
		});

		$(document).on("click", function (e) {
			var target = e.target;

			if (
				!$(target).is("#global-nav li.click-open.menu-item.open") &&
				!$(target).parents().is("#global-nav li.click-open.menu-item.open")
			) {
				$("#global-nav li.click-open.menu-item.open").removeClass("open");
			}
		});

		// reveal video and start on click
		function videoSectionClick(itemToTarget = ".stats-section__video", baseItem = "stats-section") {
			let statsVideos = document.querySelectorAll(itemToTarget);
			if (statsVideos !== null) {
				// console.log("videos exist!");
				statsVideos.forEach((item) => {
					item.addEventListener(
						"click",
						(event) => {
							const target = event.target;
							let iframeTarget = item.querySelector("iframe");
							let videoImage = item.querySelector(`.${baseItem}__video-image`);

							videoImage.classList.add(`${baseItem}__video-image--active`);
							videoImage.addEventListener("transitionend", () => {
								// console.log(this);
								videoImage.classList.add(`${baseItem}__video-image--display-none`);
							});

							item.classList.add(`${baseItem}__video--active`);

							if (iframeTarget !== null) {
								//     setTimeout(() => {
								//         iframeTarget.src = `${iframeTarget.src}&autoplay=1`;
								//     }, 100);
								var data = { method: "play" };
								iframeTarget.contentWindow.postMessage(JSON.stringify(data),"*");
							}
						},
						{ once: true }
					);
				});
			}
		}

		videoSectionClick();
		videoSectionClick(".ai-block__video-container", "ai-block");

		// *********
		// sticky image block scrolljacking
		// https://developer.mozilla.org/en-US/docs/Web/API/Intersection_Observer_API
		// *********

    function handleStickyItems() {
      const stickyItems = document.querySelectorAll(".sticky-row-content > .sticky-section");
      const stickyImageContainer = document.querySelector(".sticky-image-container");
      const stickyImages = stickyImageContainer.querySelectorAll(".sticky-image-inner");
			const siteWrapper = document.querySelector(".site-wrapper");

      if (!stickyItems) return;
			siteWrapper.classList.add("overflow-unset");
      stickyItems.forEach((stickyItem, index) => {
        // console.log("🚧 index: ", index);
        const observer = new IntersectionObserver(
          (entries) => {
            entries.forEach((entry) => {
              if (entry.isIntersecting) {
                stickyImages[index].classList.add("active");
              } else {
                stickyImages[index].classList.remove("active");
              }
            });
          },
          {
            threshold: 0.65,
          }
        );
        observer.observe(stickyItem);
      });
    }

    var stickyBlockExists = document.querySelector(".block-sticky-image");
    if (window.innerWidth > 767 && stickyBlockExists) {
      handleStickyItems();
    }

		// **************
		// footer accordion mobile
		// **************
		if (window.innerWidth < 768) {
			$('#menu-footer > li > a').on('click', function(e) {
				e.preventDefault;
				$(this).toggleClass('active');
				$(this).next('ul.sub-menu').slideToggle('400');
			})
		}

		// *************
		// pricing block
		// *************
		if ($('.ai-block-pricing-table').length) {
			$('.ai-block-pricing-table table').find('.collapsable-row').each(function() {
				var t = $(this);
				t.find('.data-row:first').on('click', function(e) {
					e.preventDefault();
					$(this);
					t.toggleClass('extended')
				})
			});

			if ($('.sticky-title-row').is(':visible')) {
				const observer = new IntersectionObserver(entries => {
					entries.forEach(entry => {
						const intersecting = entry.isIntersecting
						if (intersecting) {
							document.getElementById('sticky-title-row').style.opacity = 0;
						} else {
							document.getElementById('sticky-title-row').style.opacity = 1;
						}
					})
				}, {threshold: .8});
				observer.observe(document.getElementById('sticky-trigger'))
			}
		}
	},
	finalize() {},
};
